module.exports = __webpack_public_path__ + "static/media/sub_superlike.eb5e89be.png";